export default {
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        fontSize: '14px',
        lineHeight: '28px',
        padding: '8px',
        whiteSpace: 'pre-wrap',
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        maxWidth: '650px'
      },
      arrow: {
        color: 'rgba(0, 0, 0, 0.75)'
      }
    }
  }
};
